





































import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwPlotDepth from "@/encoding/pages/questions/exterior/PlotDepth.vue";
import iwPlotWidth from "@/encoding/pages/questions/exterior/PlotWidth.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip,
        iwAccordion: iwAccordion,
        iwPlotDepth: iwPlotDepth,
        iwPlotWidth: iwPlotWidth
    },
    data: function() {
        return {
            pathInStore: "property.land.surface",
            pathInStoreDepth: "property.land.depth",
            pathInStoreLandWidth: "property.land.landWidth",
            inputName: "land-area",
            specificId: uuidv4() as string
        };
    },
    computed: {
        landArea: function(): string|null {
            const lArea = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(lArea) {
                return lArea;
            }
            return "";
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStore) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreDepth) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreLandWidth);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        },
        isOptional: function(): boolean {
            return ["HOUSE", "LAND"].indexOf(this.getPropertyType()) === -1;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(landArea: number): void {
            if (landArea == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
                this.$store.commit("FormModule/deleteValue", this.pathInStoreDepth);
                this.$store.commit("FormModule/deleteValue", this.pathInStoreLandWidth);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": landArea});
            }
        }
    }
});

